import {IAttributes, IController, IModule} from "angular";
import {regNavn} from "../../tjenester/tredjepartsTjenestenavn";

const css = require('./logo.scss');

/** Bruk gjerne den rene UTF-8-varianten: Styreplan³ */
export class LogoKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('fkLogo', {
                controller: LogoKontroller.forInjisering(),
                template: `
<span ng-switch="$ctrl.type">
<span ng-switch-when="html" class="fk-logo-html styreplan3">Styreplan</span>
<span ng-switch-when="tekst" class="fk-logo-tekst">Styreplan3</span>
<div ng-switch-when="svgliten" class="logo fk-logo-svg">${require('./styreplan_logoikon_hvit.svg?raw')}</div>
<div ng-switch-when="svgsp" class="logo fk-logo-svg">${require('./styreplan_logo_hvit.svg?raw')}</div>
<div ng-switch-default class="logo fk-logo-svg">${require('./styreplan_logo_hvit.svg?raw')}</div>
</span>
`
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$attrs,
            LogoKontroller
        ]
    }

    constructor($attrs:IAttributes) {
        this.type = $attrs['type'];
    }

    type:'svg'|'svgliten'|'html'|'tekst'|'svgsp' = 'svg';
}
